import { Cart } from '@features/sales/domain/entities/cart/cart.entity';
import {
  CartSplitPolicy,
  OrderDraft,
  OrderType,
  SplitConfiguration,
  SplitMode
} from '@features/sales/domain/models/order/order-split.model';
import { ProductType } from '@features/sales/domain/models/product/product.model';

export class SingleOrderSplitPolicy implements CartSplitPolicy {
  supports(config: SplitConfiguration): boolean {
    return config.mode === SplitMode.SINGLE_ORDER;
  }

  partition(cart: Cart): OrderDraft[] {
    const items = cart.toDTOs();
    const isRedemption = items.every(item => item.item.type === ProductType.COMPLEMENT);

    return [
      {
        type: isRedemption ? OrderType.REDEMPTION : OrderType.SALE,
        items,
      },
    ];
  }
}




